import script from "./pswd-stp.vue?vue&type=script&setup=true&lang=js"
export * from "./pswd-stp.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__